module.exports = __webpack_public_path__ + "img/code_1.8e48bd72.png";